module.exports = __webpack_public_path__ + "assets/img/18_1828_big.34d6a6a0.jpg";